module.exports = __webpack_public_path__ + "static/lost-a0afc8044f7398ec298cd3a28e59ff92.svg";